import { AuthErrorCodes, ErrorCodes } from '~/types/gql/generated/graphql'
import type { QueryErrorResponse } from '~/types'
import type { ZodValidationIssue } from '~/types/gql/generated/graphql'

export function extractErrorCodeFromResponse(error: QueryErrorResponse): AuthErrorCodes | ErrorCodes | string {
  if (!error?.response?.errors?.length)
    return ErrorCodes.Internal

  let code = error?.response?.errors[0].code

  if (!code)
    code = error?.response?.errors[0]?.extensions?.code

  return code || ErrorCodes.Internal
}

export function extractMetadataFromResponse(error: unknown): {
  code: string | ErrorCodes | AuthErrorCodes
  message: string
  validation: ZodValidationIssue[] | null
} {
  const genericError = {
    message: 'There was a problem with your request',
    code: ErrorCodes.Internal,
  }

  if (!error || !error?.response?.errors?.length) {
    return genericError
  }

  const { code, message, validation } = error?.response?.errors[0] || {}

  if (!code || !message) {
    return genericError
  }

  return {
    code,
    message,
    validation,
  }
}
